import React, { Component } from 'react';
import { graphql } from 'gatsby';
import { PostcardForm, Layout, Wrapper } from '../components';
import './contact.scss';

class ContactPage extends Component {
  render() {
    const {
      data: {
        page: {
          data: pageData,
        },
      },
      location,
    } = this.props;
    const {
      headline,
      metaTitle,
      metaDescription,
      openGraphImage,
    } = pageData;
    const seoData = {
      metaTitle,
      metaDescription,
      openGraphImage,
    };
    return (
      <Layout location={location} seoData={seoData}>
        <Wrapper>
          <div className="contact-container">
            <div className="contact-page-headline">
              <h1>{headline.text}</h1>
              <svg className="icon" viewBox="0 0 16 22" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.827 18.665V1.695a.85.85 0 0 0-1.7 0v16.927l-5.193-4.89a.841.841 0 0 0-.832-.193.864.864 0 0 0-.58.638.882.882 0 0 0 .251.833l6.647 6.26a.844.844 0 0 0 1.16 0l6.647-6.26a.882.882 0 0 0 .252-.833.864.864 0 0 0-.58-.638.841.841 0 0 0-.833.194l-5.239 4.932z" fillRule="evenodd" />
              </svg>
            </div>
            <PostcardForm
              title="Get in touch"
              formName="contact-form-contact"
            />
          </div>
        </Wrapper>
      </Layout>
    );
  }
}

export default ContactPage;

export const pageQuery = graphql`
  query ContactPageQuery {
    site {
      siteMetadata {
        storiesSlug,
      }
    },
    page: prismicContact {
      uid,
      data {
        headline {
          html
          text
        }
        metaTitle: meta_title {
          html
          text
        },
        metaDescription: meta_description {
          html
          text
        },
        openGraphImage: open_graph_image {
          alt
          copyright
          url
        }
      }
    }
  }
`;
